export interface ICprScore {
    centerId: number,
    centerAlias: string,
    compatiblePairCount: number,
    includedCount: number,
    allDonorsProtected: number | boolean | null,
    allDonorsProtectedEndDate: string | null,
    vouchersLast12: number,
    cprScore: number
}